var MOBILE_PATTERNS = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
    /Opera Mini/i,
    /Mobile/i,
    /Tablet/i,
];
// Function to detect device type from user agent
export default function detectDeviceFromUserAgent(userAgent) {
    if (!userAgent) {
        return {
            isMobile: false,
            isTablet: false,
            isDesktop: true,
        };
    }
    var isMobileDevice = MOBILE_PATTERNS.some(function (pattern) { return pattern.test(userAgent); });
    var isTablet = /iPad|Tablet/i.test(userAgent);
    return {
        isMobile: isMobileDevice && !isTablet,
        isTablet: isTablet,
        isDesktop: !isMobileDevice && !isTablet,
    };
}
